var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "searchPanel" }, [
    _c("div", { key: "simpleSearch", staticClass: "simpleSearch" }, [
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.$emit("pesquisar", _vm.filtro)
            }
          }
        },
        [
          _c(
            "el-input",
            {
              staticClass: "input input-with-select",
              attrs: { placeholder: _vm.placeholder },
              model: {
                value: _vm.filtro.campoSimplificado,
                callback: function($$v) {
                  _vm.$set(_vm.filtro, "campoSimplificado", $$v)
                },
                expression: "filtro.campoSimplificado"
              }
            },
            [
              _c("el-button", {
                staticClass: "color-default",
                attrs: { slot: "append", icon: "el-icon-search" },
                on: { click: _vm.pesquisar },
                slot: "append"
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "button-group" }, [
      _c(
        "div",
        { staticClass: "left-buttons" },
        [
          _c(
            "el-button",
            {
              staticClass: "no-padding",
              attrs: { type: "text" },
              on: { click: _vm.limpar }
            },
            [_vm._v("Limpar")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6512b794", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6512b794","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/FiltroPvtn.vue
// module id = null
// module chunks = 